import React from 'react'

const RoundedSmallButton = ({ alphabet, title }) => {
    return (
        <>
            <button className='btn btn-sm btn-primary mx-1' style={{ borderRadius: "50%" }} title={title}>{alphabet ? alphabet : "A"}</button>
        </>
    )
}

export default RoundedSmallButton